import { contactContent } from "./contact";

export const contactViewContent = { contactContent };
